<template>
  <div class="customer" :class="source && source == 'customer' ? 'customer-source' : ''">
    <div class="customer-title" v-if="!source">客户案例</div>
    <!-- <div class="auth-content" v-if="!source">
      <div class="auth-scroll-content">
        <div class="auth-item" v-for="(auth, index) in logoNumber" :key="index">
          <el-image class="auth-img" :src="getLogoUrl(index + 1)"></el-image>
        </div>
      </div>
    </div> -->

    <div class="logo-carousel">
      <div class="carousel-row" v-for="(row, rowIndex) in 5" :key="rowIndex">
        <div class="carousel-track">
          <!-- 第一组图片 -->
          <div class="carousel-item" v-for="(item, index) in getRowItems(rowIndex)"
            :key="'first-' + rowIndex + '-' + index">
            <el-image :src="getLogoUrl(item)" fit="contain" class="carousel-img"></el-image>
          </div>
          <!-- 第二组图片（复制以实现无缝循环） -->
          <div class="carousel-item" v-for="(item, index) in getRowItems(rowIndex)"
            :key="'second-' + rowIndex + '-' + index">
            <el-image :src="getLogoUrl(item)" fit="contain" class="carousel-img"></el-image>
          </div>
        </div>
      </div>
    </div>

    <div class="tab">
      <div class="tab-item" v-for="(item, index) in customerList" :key="index">
        <div class="tab-item-title" :class="{ active: activeTab == item.title }" @click="handleClick(item)">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="content">
      <div v-for="(childItem, childIndex) in contentList" :key="childItem.title" class="content-item">
        <el-image class="content-item-img" :key="childItem.src + childItem.title" :src="childItem.src"></el-image>
        <div class="content-item-title" @click="docHtmlPath({
          title: childItem.title,
          fileName: childItem.fileName,
          source: '首页案例'
        })">
          <div>{{ childItem.title }}</div>
        </div>
        <div class="content-item-info">{{ childItem.info }}</div>
      </div>
    </div>
    <!--  <div class="customer-logo-more eno-common-button" v-if="!source">
      了解更多客户案例
    </div> -->
  </div>
</template>

<script>
import { config } from "@/constant/config";
import { docHtmlPath } from "@/utils";

export default {
  props: {
    source: String,
  },
  data() {
    return {
      customerList: config.customer,
      logoNumber: config.homeLogoNumber,
      activeTab: "单体医院·多院区",
      contentList: config.customer[0].list,
      // 按每行colCount个，拆分logoNumber为二维数组
      colCount: 7,
    };
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {
    docHtmlPath,

    getLogoUrl(index) {
      return require(`../../../assets/images/home/customer/${index}.png`);
    },
    handleClick(item) {
      this.activeTab = item.title;
      this.contentList = item.list;
    },
    getRowItems(rowIndex) {
      const totalImages = this.logoNumber || 56; // 图片总数
      const rows = 5; // 固定5行

      // 计算每行图片数（尽量平均分配）
      const basePerRow = Math.floor(totalImages / rows);
      const remainder = totalImages % rows;

      // 计算当前行开始和结束的索引
      let startIndex = 0;
      for (let i = 0; i < rowIndex; i++) {
        startIndex += basePerRow + (i < remainder ? 1 : 0);
      }

      const rowCount = basePerRow + (rowIndex < remainder ? 1 : 0);
      const items = [];

      for (let i = 0; i < rowCount; i++) {
        // 图片索引从1开始
        items.push(startIndex + i + 1);
      }

      return items;
    }
  },
};
</script>

<style lang="less" scoped>
.customer {
  background-color: @mainTextColor;
  padding: @commonPadding @commonPadding 0 @commonPadding;

  .customer-title {
    font-size: 40px;
    padding-bottom: 60px;
  }

  .customer-content {
    display: flex;
    flex-direction: column;

    .customer-item {
      display: grid;
      grid-template-columns: 1fr 1fr;
      height: 460px;

      &:nth-child(even) {
        direction: rtl;
      }

      .customer-img {
        overflow: hidden;

        .customer-item-img {
          width: 100%;

          &:hover {
            cursor: pointer;
            animation-name: scaleImage;
            animation-duration: 0.6s;
            animation-fill-mode: forwards;
            object-fit: cover;
            font-family: "object-fit:cover;";
          }
        }
      }

      .customer-item-right {
        display: grid;
        grid-template-rows: 1fr 1fr 1fr;
        grid-row-gap: 20px;
        padding: 76px 60px;
        background-color: @grayBgColor;
        direction: ltr;

        .customer-item-title {
          font-size: 30px;
          color: @black;
          line-height: 130%;
        }

        .customer-item-info {
          font-size: 16px;
          color: @mainGrayColor2;
          line-height: 150%;
        }

        .customer-item-btn {}
      }
    }
  }

  /*  .customer-logo {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 60px;
    grid-row-gap: 40px;
    padding: 30px 0;
  }

  .customer-logo-more {
    margin: 0 auto;
  } */
}

.customer-source {
  padding: 68px 0 0;
}

/deep/ .el-carousel__indicators--outside {
  .el-carousel__indicator.is-active button {
    background-color: @mainColor !important;
  }
}

/deep/ .el-carousel__button {
  height: 5px;
}

@keyframes scaleImage {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.tab {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  font-size: 20px;
  margin-top: 60px;

  .tab-item {
    text-align: center;
    cursor: pointer;

    .tab-item-title {
      padding: 17px 0;
    }
  }

  .active {
    border-bottom: 6px solid @mainColor;
    font-weight: 600;
  }
}

.content {
  padding: @commonPadding;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 44px;

  .content-item {
    display: flex;
    flex-direction: column;
    position: relative;
    //padding-bottom: 100px;
    cursor: pointer;

    .content-item-img {
      width: 100%;
      height: 200px;
    }

    .content-item-title {
      margin: 20px 0px;
      font-size: 20px;
      height: 85px;

      &:hover {
        text-decoration: underline;
      }
    }

    .content-item-info {
      color: @mainGrayColor2;
      font-size: 16px;

      display: -webkit-box;
      -webkit-line-clamp: 3;
      /* 固定3行 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      /* 超出部分隐藏 */
      text-overflow: ellipsis;
      /* 超出3行末尾显示省略号 */
    }

    .content-item-btn {
      position: absolute;
      bottom: 10px;
      width: 84px;
      height: 38px;
      font-size: 14px;
      padding: 12px;
    }
  }
}

.logo-carousel {
  //margin: 30px 0;
  overflow: hidden;
  background-color: @mainGrayColor4;
  padding: 30px;
}

.carousel-row {
  height: 60px;
  /* 可以根据需要调整 */
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
}

.carousel-track {
  display: flex;
  position: absolute;
  height: 100%;
  width: max-content;
  animation: scrollLeft 30s linear infinite;
}

/* 奇数行向左滚动 */
.carousel-row:nth-child(odd) .carousel-track {
  animation: scrollLeft 30s linear infinite;
}

/* 偶数行向右滚动 */
.carousel-row:nth-child(even) .carousel-track {
  //scrollRight
  animation: scrollLeft 35s linear infinite;
}

.carousel-item {
  flex-shrink: 0;
  width: 251px;
  /* 可以根据需要调整 */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  // 置灰
  // filter: grayscale(100%);
  opacity: 1;
  transition: all 0.3s ease;

  &:hover {
    filter: grayscale(0%);
    opacity: 1;
    transform: scale(1.05);
  }
}

/* 动画定义 */
@keyframes scrollLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes scrollRight {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

@media @mobile {
  .customer {
    padding: 30px @commonPadding_h5;

    .customer-title {
      font-size: @fontSize24;
      padding-bottom: 20px;
    }
  }

  .customer-source {
    padding: 68px 0 0;
  }


  @keyframes scaleImage {
    0% {
      transform: scale(1);
    }

    100% {
      transform: scale(1.1);
    }
  }

  .tab {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    font-size: @fontSize16;
    margin-top: 0px;

    .tab-item {
      text-align: center;
      cursor: pointer;

      .tab-item-title {
        padding: 17px 0;
      }
    }

    .active {
      border-bottom: 6px solid @mainColor;
      font-weight: 600;
    }
  }

  .content {
    padding: 40px 0 0 0;
    display: flex;
    flex-direction: column;
    gap: 40px;

    .content-item {
      display: flex;
      flex-direction: column;

      .content-item-title {
        font-size: @fontSize20;
        height: 100%;
      }

      .content-item-info {
        font-size: @fontSize14;
      }
    }
  }

  .logo-carousel {
    display: none;
  }

}
</style>
